export const authenticationService = {
  baseURL: 'https://api.auth.cerclex.com',
};

export const IWMService = {
  baseURL: 'https://server1.wasteknot.io',
};
;

